module.exports = [{"type":"title","text":"2025-06-30"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"U本位永續合約：‘合約交易幣對’增加displayName字段。"},{"type":"html","text":"币本位永續合約：‘查詢合約基礎信息’增加displayName字段。"},{"type":"html","text":"現貨：‘現貨交易對’增加displayName字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-06-30.json
// module id = qi3T
// module chunks = 3